import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sd_exercise_play",
  "use": "icon-sd_exercise_play-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sd_exercise_play\">\n<path d=\"M35.25 22.701C36.25 23.2783 36.25 24.7217 35.25 25.299L15 36.9904C14 37.5677 12.75 36.846 12.75 35.6913L12.75 12.3087C12.75 11.154 14 10.4323 15 11.0096L35.25 22.701Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol